import { render, staticRenderFns } from "./EmailDraft.vue?vue&type=template&id=e958e95c&"
import script from "./EmailDraft.vue?vue&type=script&lang=js&"
export * from "./EmailDraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports